'use client';

import { useEffect } from 'react';

// This component becomes the top-level error boundary for the entire App Router tree.
// Next.js automatically uses `app/global-error.tsx` when any error bubbles past a route
// segment that doesn’t have its own `error.tsx`.  Here we log the error and provide an
// actionable fallback for the user.

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Log error once the component mounts
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('Global error boundary caught:', error);
    // TODO: Replace with call to monitoring service (e.g., Sentry.captureException(error))
  }, [error]);

  return (
    <html>
      <body className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center text-foreground">
        <h1 className="mb-3 text-2xl font-semibold">Something went wrong</h1>
        <p className="mb-6 max-w-md text-sm opacity-80">
          An unexpected error occurred while loading the page. You can try refreshing or
          disabling browser extensions. If the problem persists, please contact support.
        </p>
        <button
          type="button"
          onClick={reset}
          className="rounded bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
        >
          Refresh Page
        </button>
      </body>
    </html>
  );
} 